import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { mailSummaryFailedEpic } from './mailSummaryFailedEpic';

export const mailStatusEpic = () =>
  combineEpics(withAppCrashIfException('mailSummaryFailedEpic', mailSummaryFailedEpic()));
